function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
export var arrayIntersection = function arrayIntersection(a1, a2) {
  return a1 === null || a1 === void 0 ? void 0 : a1.filter(function (x) {
    return a2 === null || a2 === void 0 ? void 0 : a2.includes(x);
  });
};
export var uniqueArray = function uniqueArray(a) {
  if (!(a !== null && a !== void 0 && a.length)) {
    return null;
  }
  if (_typeof(a) === _typeof({})) {
    var jsonSet = new Set(a.map(JSON.stringify));
    return Array.from(jsonSet).map(JSON.parse);
  }
  return _toConsumableArray(new Set(a));
};
export var dedupById = function dedupById(arr) {
  return arr.filter(function (v, i, a) {
    return a.findIndex(function (v2) {
      return v2.id === v.id;
    }) === i;
  });
};
//# sourceMappingURL=arrayUtils.js.map